<template>
    <div class="page">
        <div class="page_content">
           <div class="top">
               <div class="top_title" @mouseover="onMouseOver" @mousemove="onMouseMove" @mouseout="onMouseOut">
                   <div>{{text.title[lang]}}</div>
                   <div :class="{'top_title_after': true, 'anim_spotlight': !this.isMouseOver}" :style="{'--x': pos_x, '--y': pos_y}">{{text.title[lang]}}</div>
               </div>
               <div class="downtext">{{text.downtext[lang]}}</div>
               <div class="icon_down">︾</div>
            </div>
            <div class="subtitle" data-aos="fade-down" data-aos-duration="500">{{text.subtitle[lang]}}</div>
            <div class="middle2" data-aos="fade-down" data-aos-duration="800">
                <div class="mid_title2">{{text.midpart1.title[lang]}}</div>
                <div class="mid_content2">{{text.midpart1.content[lang]}}</div>
            </div>
            <div class="middle3" data-aos="fade-down" data-aos-duration="500">
                <img class="img_base" src="../assets/images/marketing_1.jpg" alt="">
            </div>
            <div class="middle1">
                <div class="mid_textbox1" data-aos="fade-down" data-aos-duration="600">
                    <div class="mid_title">{{text.midpart2.title[lang]}}</div>
                    <div class="mid_content">{{text.midpart2.content[lang]}}</div>
                </div>
                <div class="mid_img1" data-aos="fade-down" data-aos-duration="500">
                    <img class="img_base" src="../assets/images/marketing_2.jpg" alt="">
                </div>
            </div>
            <div class="middle3" data-aos="fade-down" data-aos-duration="500">
                <img class="img_base" src="../assets/images/marketing_3.jpg" alt="">
            </div>
            <div class="middle2" data-aos="fade-down" data-aos-duration="600">
                <div class="mid_title2">{{text.midpart3.title[lang]}}</div>
                <div class="mid_content2">{{text.midpart3.content[lang]}}</div>
            </div>
        </div>
        <Foot/>
        <Nav></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {marketingText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
export default {
    components: {
        Nav,
        Foot
    },
    data () {
        return {
            text: marketingText,
            pos_x: 0,
            pos_y: 0,
            isMouseOver: false
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        onMouseOver (e) {
            this.isMouseOver = true
            this.pos_x = e.offsetX
            this.pos_y = e.offsetY
        },
        onMouseMove (e) {
            if (!this.isMouseOver) return
            this.pos_x = e.offsetX
            this.pos_y = e.offsetY
        },
        onMouseOut () {
            this.isMouseOver = false
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '服务-数字营销'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.02turn, #654C71, #B3B2D0);
    position: relative;
    text-align: center;
}
.top_title {
    width: 60%;
    position: absolute;
    top: 45%;
    left: 20%;
    transform: translateY(-50%);
    font-size: 2.75rem;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.2);
}
.top_title_after {
    width: 100%;
    height: 100%;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-clip-path: ellipse(100px 100px at calc(var(--x) * 1px ) calc(var(--y) * 1px));
    clip-path: ellipse(100px 100px at calc(var(--x) * 1px ) calc(var(--y) * 1px));
}
.anim_spotlight {
    animation: spotlight 5s infinite;
}
@keyframes spotlight {
  0% {
    -webkit-clip-path: ellipse(100px 100px at 0% 50%);
    clip-path: ellipse(100px 100px at 0% 50%);
  }
  
  50% {
    -webkit-clip-path: ellipse(100px 100px at 100% 50%);
    clip-path: ellipse(100px 100px at 100% 50%);
  }
  
  100% {
    -webkit-clip-path: ellipse(100px 100px at 0% 50%);
    clip-path: ellipse(100px 100px at 0% 50%);
  }
}
.downtext {
    width: 60%;
    position: absolute;
    bottom: 3rem;
    left: 20%;
    font-size: 1.125rem;
    color: #fff;
}
.icon_down {
    width: 60%;
    position: absolute;
    bottom: 0;
    left: 20%;
    font-size: 2rem;
    color: #fff;
    animation: fade-in-out 1s ease-in-out infinite alternate;
}
@keyframes fade-in-out {
    0% { opacity: 0;}
    100% { opacity: 1;}
}
.subtitle {
    width: 60%;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.5;
    margin: 10% 20%;
}
.middle1 {
    width: 80%;
    margin: 0 10% 10% 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.mid_textbox1 {
    width: 34vw;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.mid_title {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.5;
}
.mid_content {
    width: 100%;
    color: #666;
    font-size: 0.875rem;
    line-height: 1.5;
}
.mid_img1 {
    width: 40vw;
    height: 46vw;
    background: #B6ADB4;
}
.mid_img1 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.middle2 {
    width: 80%;
    margin: 0 10% 5% 10%;
    text-align: left;
    line-height: 1.5;
}
.mid_title2 {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
}
.mid_content2 {
    color: #666;
    font-size: 0.875rem;
}
.middle3 {
    width: 80vw;
    margin: 0 10% 10% 10%;
    height: 48vw;
    background: #B6ADB4;
}
.middle3 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
@media screen and (max-width: 756px) {
    .mid_textbox1 {
        width: 40vw;
    }
    .mid_img1 {
        width: 34vw;
        height: 50vw;
    }
}
</style>
